export default __webpack_public_path__ + "img/InterDisplay-SemiBoldItalic_59f9051.woff2";